import { init } from "@instantdb/react";
import schema from "../../instant.schema.ts";
import { instantAppId } from "../../constants.ts";

export const { useAuth, transact, tx, auth, queryOnce, useQuery } = init({
  appId: instantAppId,
  schema,
});
